import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { SpotIcon } from '@cbhq/cds-web/illustrations';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

import { ProductItem } from ':cloud/types/ts_types';

/** Grey Cards */
export function NewProjectCard({ title, spotIconName, shortDesc, linkToRoute }: ProductItem) {
  const history = useHistory();

  const handleNewProjectPress = useCallback(() => {
    history.push(linkToRoute);
  }, [history, linkToRoute]);

  return (
    <Box background="backgroundAlternate" borderRadius="rounded" maxWidth={400}>
      <Pressable background="transparent" onPress={handleNewProjectPress} width="100%">
        <VStack alignItems="flex-start" spacing={5} width="100%">
          <SpotIcon name={spotIconName} />
          <TextTitle3 as="h1" spacingTop={2} spacingBottom={0.5}>
            {title}
          </TextTitle3>
          <HStack justifyContent="space-between" width="100%">
            <TextBody as="p" color="foregroundMuted">
              {shortDesc}
            </TextBody>
          </HStack>
        </VStack>
      </Pressable>
    </Box>
  );
}
